import React from 'react'
import { translateResourceString } from '../../../util/translationUtility';

const CheckoutPageHeader = () => (
    <h1 className="headline headline-xl mb-3">
        <i className="fas fa-lock pr-2"></i>
        {translateResourceString("/Checkout/PageHeader")}
    </h1>
)

export default CheckoutPageHeader